import * as actions from "../actions/constants"
import { initialState } from "./state"

const initialAction = {
  type: '',
  payload: '' || [] || 1 || true
}

export const checkoutReducer = (state = initialState, action = initialAction) => {
  switch (action.type) {
    case actions.INCREMENT:
      return {
        ...state,
        checkoutValue: state.checkoutValue + action.payload
      }
    case actions.CHECKOUTDATA:
      return {
        ...state,
        checkoutdata: action.payload,
        paymentMethod: action.payload.productDetails.method
      }
    case actions.PAYMENTSESSION:
      return {
        ...state,
        paymentsession: action.payload
      }
    case actions.PAYMENTPUBLICSESSION:
      return {
        ...state,
        paymentpublicsession: action.payload
      }
    case actions.PAYMENTOPTIONS:
      return {
        ...state,
        promiseId: action.payload.promiseId,
        products: action.payload.products
      }
      case actions.PAYMENTTYPE:
        return {
          ...state,
          promiseId: action.payload.promiseId,
          paymentMethod: action.payload.method
        }
    default:
      return { ...state }
  }
}